<template>
    <el-dialog title="提示" :visible.sync="dialogVisible" width="30%" :before-close="close" class="recorderwrap">
        <!-- 录音 -->
        <div class="recorderbox">
            <div class="recwave"></div>
            <div class="time">{{current_time | time}}</div>
            <div class="audioplaybox"><audio controls id="recaudio" @timeupdate="timeupdate" :src="audiosrc"></audio></div>
        </div>

        <div slot="footer" class="dialog-footer">
            <div class="btn_recstart iconfont" @click="recControls" v-if="!file">{{playflag?'&#xe779;':'&#xe73b;'}}</div>
            <span v-if="file && !playflag">
                <div class="btn_recrestart" @click="recStart">重录</div>
                <div class="btn_recstart iconfont" @click="play">&#xe73d;</div>
                <div class="btn_recsend" @click="send">发送</div>
            </span>
        </div>
    </el-dialog>
</template>

<script>
    import {
        mapGetters,
        mapMutations
    } from 'vuex'
    // import base64 from '@/utils/base64.js'
    import Recorder from 'recorder-core/recorder.mp3.min'
    import 'recorder-core/src/extensions/waveview'
    import uploadfile from '@/utils/upload.js'
    export default {
        name:'recorderbox',
        data() {
            return {
                rec: null, //音频载体
                audiosrc: null,
                duration:0,
                file:'',
                playflag:false,
                wave:null,
                wavearr:[],
                current_time:0
            }
        },
        props:{
            dialogVisible:{}
        },
        computed: {
            ...mapGetters('im', [
                'selectfriendids'
            ])
        },
        mounted() {
            console.log(this.dialogVisible)
            this.recOpen()
        },
        methods:{
            ...mapMutations('im', [
                'MSGID'
            ]),

            play(){
                var audio = document.getElementById('recaudio');
                if (audio.paused) {
                    audio.play();
                    this.wave.input([0], 0,16000)
                    for(let i =0;i<this.wavearr.length;i++){
                        setTimeout(()=>{
                            this.wave.input(this.wavearr[i].buffers, this.wavearr[i].powerLevel, this.wavearr[i].bufferSampleRate)
                        },85*i)
                    }
                }
            },

            timeupdate(e){
                this.current_time = e.target.currentTime
            },

            //显示录音

            recOpen(success) {
                let _this = this;
                this.rec = Recorder({
                    type: "mp3",
                    sampleRate: 16000,
                    bitRate: 16,
                    onProcess(buffers, powerLevel, bufferDuration, bufferSampleRate) {
                        //录音实时回调，大约1秒调用12次本回调
                        _this.wave.input(buffers[buffers.length - 1], powerLevel, bufferSampleRate)
                        _this.current_time = bufferDuration/1000
                        let times = new Date()
                        _this.wavearr.push({
                            buffers:buffers[buffers.length - 1],
                            powerLevel:powerLevel,
                            bufferSampleRate:bufferSampleRate
                        })
                        if(bufferDuration/1000 >=60){
                            //60s自动停止
                            _this.recStop()
                        }
                    }
                });

                this.rec.open(() => {
                    _this.wave = Recorder.WaveView({
                        elem: ".recwave"
                    });
                    success && success();
                    this.wave.input([0], 0, 16000)
                }, (msg, isUserNotAllow) => {
                    //dialog&&dialog.Cancel(); 如果开启了弹框，此处需要取消
                    this.$message.error((isUserNotAllow ? "UserNotAllow，" : "") + "无法录音:" + msg);
                    this.close()
                });
            },

            recControls(){
                this.playflag? this.recStop():this.recStart()
            },

            recStart() { //打开了录音后才能进行start、stop调用
                this.file = ''
                this.wavearr= []
                this.rec.start();
                this.playflag = true
            },

            recStop() {
                this.rec.stop((blob, duration) => {
                    console.log(blob, (window.URL || webkitURL).createObjectURL(blob), "时长:" + duration + "ms");
                    this.playflag = false
                    this.duration = duration
                    console.log(this.duration,'时间')
                    //this.rec.close(); //释放录音资源，当然可以不释放，后面可以连续调用start；但不释放时系统或浏览器会一直提示在录音，最佳操作是录完就close掉
                    // this.rec = null;
                    this.current_time = 0
                    //已经拿到blob文件对象想干嘛就干嘛：立即播放、上传
                    this.audiosrc = (window.URL || webkitURL).createObjectURL(blob)
                    /*立即播放例子*/
                    // var audio=document.createElement("audio");
                    // audio.controls=true;
                    // document.body.appendChild(audio);
                    //简单的一哔，注意不用了时需要revokeObjectURL，否则霸占内存
                    // audio.src=(window.URL||webkitURL).createObjectURL(blob);
                    // audio.play();
                    var reader=new FileReader();
                    reader.onloadend= () => {
                        let uid = uploadfile.generateUUID()
                        console.log(reader.result,blob)
                        let file = uploadfile.dataURItoFile(reader.result,'audio/mp3',uid+'.mp3')
                        console.log(file)
                        this.file = file

                    };
                    reader.readAsDataURL(blob);

                }, function(msg) {
                    console.log("录音失败:" + msg);
                    this.rec.close(); //可以通过stop方法的第3个参数来自动调用close
                    this.rec = null;
                });
            },

            close(){
                if(this.rec){
                    //关闭并销毁录音
                    this.rec.close();
                    this.rec = null;
                }
                this.$emit('closeRecorder',false)
            },
            send(){
                if(this.file != ''){
                    //获取oss
                    uploadfile.getossbase(this.file).then(osdata=>{
                        //上传
                        uploadfile.uploadform(osdata).then(updata=>{
                            //成功回调
                            this.uploadSuccess(updata,osdata.fileidlist)
                            this.close()
                        })
                    })
                }

            },
            uploadSuccess(data,fileidlist) {
                let {file,uuid} = data
                console.log( file,uuid, '上传成功',data,fileidlist)
                let contenttype = null
                let filecon = null
                if (file.type === 'audio/mp3') {
                    contenttype = 3
                    let url = fileidlist[uuid].host.replace('http://','') + fileidlist[uuid].filename
                    console.log(url,url.split('://'))
                    url = url.split('://')[0]
                    filecon = {
                        Duration: this.duration,
                        Thumb: fileidlist[uuid].host + fileidlist[uuid].filename,
                        LinkUrl:url
                    }
                    console.log(filecon)
                    let suuid = uploadfile.generateUUID()
                    filecon = JSON.stringify(filecon)
                    // filecon = base64.b64EncodeUnicode(filecon)
                    this.MSGID(suuid) //保存uuid

                    this.socketApi.sendSock({
                        msgType: "TALK_TO_FRIEND_REQ",
                        msgContent: {
                            weChatId: this.selectfriendids.wechatContactinfo.wechatid,
                            friendId: this.selectfriendids.wechatContactinfo.friendid,
                            contentType: contenttype,
                            content: filecon,
                            sendUuid: suuid
                        }
                    })
                    this.file  = ''
                    this.duration = ''
                }
            },

        },
    }
</script>
<style lang="less" scoped>
    .recwave{
        height: 70px;
        width: 210px;
        margin: 20px auto;
        &.isplay{
            background: url(/static/img/boxing.png) center no-repeat;
            background-size: 100% 100%;
        }
    }
    .audioplaybox{
        audio{
            width: 0;
            height: 0;
        }

    }
    .time{
        text-align: center;
        margin-top: 25px;
    }
    .dialog-footer{
        text-align: center;
        div{
            display: inline-block;
        }
        .btn_recstart{
            color: #0D9CFF;
            font-size: 36px;
            cursor: pointer;
            vertical-align: middle;
        }
        .btn_recrestart{
            margin-right: 70px;
            font-size: 14px;
            cursor: pointer;
        }
        .btn_recsend{
            margin-left: 70px;
            font-size: 14px;
            color: #0099FF;
            cursor: pointer;
        }
    }
</style>
<style>
    .recorderwrap .el-dialog{
        width:360px!important;
        height:288px;
    }

    .recorderwrap .el-dialog__header .el-dialog__headerbtn{
        top: 20px;
    }
</style>



// WEBPACK FOOTER //
// src/views/customerservice/components/recorder.vue